module.exports = __webpack_public_path__ + "img/drlaura_hero_desktop.515739aa.png";